import { render } from "./InstancePropertyInput.vue?vue&type=template&id=6106ff76&scoped=true&ts=true"
import script from "./InstancePropertyInput.vue?vue&type=script&lang=ts"
export * from "./InstancePropertyInput.vue?vue&type=script&lang=ts"

import "./InstancePropertyInput.vue?vue&type=style&index=0&id=6106ff76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6106ff76"]])

export default __exports__